import { MantineProvider, ColorScheme, ColorSchemeProvider } from '@mantine/core'
import { useCallback } from 'react'
import { useLocalStorage } from '@mantine/hooks'
import ReactGA from 'react-ga4'
import { Footer, Header, RouteChangeTracker } from './components'
import { HomePage } from './pages'
import config from './config'
import { BrowserRouter } from 'react-router-dom'
import { GlobalStyles } from './styles'

const TRACKING_ID = config.GOOGLE_TRACKING_ID
if (TRACKING_ID) ReactGA.initialize(TRACKING_ID)

const App: React.FC = () => {
  const [colorScheme, setColorScheme] = useLocalStorage<ColorScheme>({
    key: 'color-scheme',
    defaultValue: 'dark',
  })

  const toggleColorScheme = useCallback(
    (value?: ColorScheme) => {
      setColorScheme(value || colorScheme === 'dark' ? 'light' : 'dark')
    },
    [colorScheme, setColorScheme],
  )

  return (
    <BrowserRouter>
      <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
        <MantineProvider
          withGlobalStyles
          withNormalizeCSS
          theme={{
            colorScheme: colorScheme,
            fontFamily: 'Poppins, sans-serif',
            headings: {
              fontFamily: 'Poppins, sans-serif',
            },
          }}
        >
          <GlobalStyles />
          <RouteChangeTracker />
          <Header />
          <HomePage />
          <Footer />
        </MantineProvider>
      </ColorSchemeProvider>
    </BrowserRouter>
  )
}

export default App
